import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// auth and pages
import AuthRoutes from "./routes";

// components
import Login from "../screens/auth/login";
import Register from "../screens/auth/register";
import PrivateRoute from "./private";
import VerifyOrganization from "../screens/auth/verify-organization";
import Homepage from "../screens/home";
import RequestForm from "../screens/auth/register/RequestForm";
import SubscriptionSuccess from "../screens/subscription/success";
import { SubscriptionFailedPage } from "../screens/subscription/failed";
import PricingPage from "../screens/pricing/ai";
import TermsAcceptance from "../screens/policies/agreement";
import MakePayment from "../screens/pricing/ai/pay";
// import PaymentSelection from "../screens/payment/payment-selection";
import OrderForm from "../screens/payment/order-form";
import SlaPage from "../screens/policies/sla-brief";
import PrivacyPolicy from "../screens/policies/policy";
import TermsOfService from "../screens/policies/terms";
import DataProcessingAddendum from "../screens/policies/dpa";
import DataEncrypPage from "../screens/policies/data-encryption";
import TrustCenterScreen from "../screens/policies/trust-center";
import CookiePolicyScreen from "../screens/policies/cookie-policy";
import CaseStudyScreen from "../screens/policies/case-study";
import DemoVideo from "../screens/demo-video";
import AccessControls from "../screens/policies/access-controls";
import ResponsibleAI from "../screens/policies/responsible-ai";
import Unsubscribe from "../screens/unsubscribe";
import ForgetPassword from "../screens/auth/forget-password";
import ResetPassword from "../screens/auth/reset-password";
import MSA from "../screens/policies/msa";
import MOU from "../screens/policies/mou";
import MainPricing from "../screens/pricing";
import ConsolePricing from "../screens/pricing/console";
import ConsolePay from "../screens/pricing/console/pay";
import PricingDirect from "../screens/pricing/direct/Pricing";
import DirectPay from "../screens/pricing/direct/pay";
import SlaPageAgreement from "../screens/policies/sla";
import OnboardingForm from "../screens/policies/onboarding-form";
import PaymentUpload from "../screens/payment/payment-upload";
import GoLivePage from "../screens/policies/go-live";
import GoLivePrePage from "../screens/policies/go-live-pre";
import PreLivePage from "../screens/policies/pre-live";
import MasterServiceAgreementPage from "../screens/policies/master-service-agreement";
import MsaPrePage from "../screens/policies/msa-pre";
import DPAPage from "../screens/policies/data-processing";
import DpaPrePage from "../screens/policies/dpa-pre";
import Suggestions from "../screens/suggestions";
import NewPaymentSelection from "../screens/payment/new-payment-selection";
import SchedulingPage from "../screens/scheduling";
import ApproveOnboarding from "../screens/onboarding/ApproveOnboarding";
import OnboardingFormOld from "../screens/policies/onboarding-form-old";
import PostOnboardAgreementPage from "../screens/policies/post-onboard-agreement";

export interface IApplicationProps {}

const MainNavigation: React.FC<IApplicationProps> = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/request" element={<Register />} />
        <Route path="verify-organization" element={<VerifyOrganization />} />
        <Route path="/request__" element={<RequestForm />} />
        <Route path="/billing/cancel" element={<SubscriptionFailedPage />} />
        <Route path="/billing/success" element={<SubscriptionSuccess />} />
        <Route path="/price" element={<PricingPage />} />
        <Route path="/agreement" element={<TermsAcceptance />} />
        {/* <Route path="/payment-selection" element={<PaymentSelection />} /> */}
        <Route path="/order-form" element={<OrderForm />} />
        <Route path="/sla-brief" element={<SlaPage />} />
        <Route path="/pay" element={<MakePayment />} />
        <Route path="/policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/dpa" element={<DataProcessingAddendum />} />
        <Route path="/msa" element={<MSA />} />
        <Route path="/mou" element={<MOU />} />
        <Route path="/data-encryption" element={<DataEncrypPage />} />
        <Route path="/trust-center" element={<TrustCenterScreen />} />
        <Route path="/cookie-policy" element={<CookiePolicyScreen />} />
        <Route path="/case-study" element={<CaseStudyScreen />} />
        <Route path="/access-controls" element={<AccessControls />} />
        <Route path="/responsible-ai" element={<ResponsibleAI />} />
        <Route path="/demo" element={<DemoVideo />} />
        <Route
          path="/unsubscribe-reminders/:encodedData"
          element={<Unsubscribe />}
        />
        <Route path="/unsubscribe" element={<Unsubscribe />} />
        {/* <Route path="/direct" element={<DirectHome />} /> */}
        {/* New Pricing */}
        <Route path="/pricing" element={<MainPricing />} />
        {/* <Route path="/pricing" element={<PricingPage />} /> */}
        <Route path="/pricing/console" element={<ConsolePricing />} />
        <Route path="/pricing/console/pay" element={<ConsolePay />} />
        <Route path="/pricing/direct" element={<PricingDirect />} />
        <Route path="/pricing/direct/pay" element={<DirectPay />} />
        <Route path="/sla" element={<SlaPageAgreement />} />
        <Route path="/onboarding-form" element={<OnboardingForm />} />
        <Route path="/onboarding-form-old" element={<OnboardingFormOld />} />
        <Route path="/payment-upload" element={<PaymentUpload />} />
        <Route path="/go-live" element={<GoLivePage />} />
        <Route path="/go-live-pre" element={<GoLivePrePage />} />
        <Route path="/pre-live" element={<PreLivePage />} />
        <Route
          path="/master-service-agreement"
          element={<MasterServiceAgreementPage />}
        />
        <Route path="/msa-pre" element={<MsaPrePage />} />
        <Route path="/data-processing" element={<DPAPage />} />
        <Route path="/dpa-pre" element={<DpaPrePage />} />
        <Route path="/suggestions" element={<Suggestions />} />
        <Route path="/payment-selection" element={<NewPaymentSelection />} />
        <Route path="/schedule" element={<SchedulingPage />} />
        <Route path="/approve-onboarding" element={<ApproveOnboarding />} />
        <Route path="/post-onboard-agreement" element={<PostOnboardAgreementPage />} />

        <Route
          path="/*"
          element={
            <PrivateRoute>
              <AuthRoutes />
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default MainNavigation;
